export default __webpack_public_path__ + "pi1-1QAAT/components/BorrowerCards/images/avatar-secondary-f6cc9fdb51654c9d591db69f33e3e1df.svg";